export const toolbarItems = [
  'undo',
  'redo',
  '|',
  'insertMergeField',
  'previewMergeFields',
  '|',
  // 'importWord',
  'exportWord',
  'exportPdf',
  // 'caseChange',
  // 'findAndReplace',
  // 'fullscreen',
  '|',
  'heading',
  'style',
  'formatPainter',
  '|',
  'fontSize',
  'fontFamily',
  'fontColor',
  'fontBackgroundColor',
  '|',
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'subscript',
  'superscript',
  // 'code',
  'removeFormat',
  '|',
  'emoji',
  // 'specialCharacters',
  'horizontalLine',
  'pageBreak',
  'link',
  // 'bookmark',
  'insertImage',
  'insertImageViaUrl',
  'insertTable',
  // 'tableOfContents',
  // 'insertTemplate',
  // 'highlight',
  // 'blockQuote',
  '|',
  'alignment',
  'lineHeight',
  '|',
  'bulletedList',
  'numberedList',
  'multiLevelList',
  'todoList',
  'outdent',
  'indent',
];
